import * as z from "zod";

export const setSimCardErrorResponse = z.object({
  code: z.literal("50189"),
});
